import React from 'react';
import ImagemSharePointBase from '../../ImagemSharePoint';

// =====================================================================
// Miniatura de foto da CONSERVAÇÃO PREDIAL.
//
// A implementação é a do módulo (`../ImagemSharePoint.js`), compartilhada com o
// Programa de Certificação desde 2026-08-17. Aqui fica só o prefixo do proxy —
// ⚠️ que NÃO é o `API` local de cada tela: a de Ordens de Serviço fala com
// `/api/manutencao/conservacao/os`, mas o proxy de foto vive um nível acima.
// Fixar o prefixo num lugar só evita esse tropeço em cada chamada.
// =====================================================================

const API = '/api/manutencao/conservacao';

const ImagemSharePoint = (props) => <ImagemSharePointBase apiBase={API} {...props} />;

export default ImagemSharePoint;
